class MiReportService {

    constructor($http, toaster, reportName, dateSelectionRequired) {
        this.$http = $http;
        this.toaster = toaster;
        this.reportName = reportName;
        this.isDownloadingReport = false;
        this.dateRangeInvalid = false;
        this.noRecordsFound = false;
        this.text = null;

        this.dateSelectionRequired = false;
        if (dateSelectionRequired !== undefined) {
            this.dateSelectionRequired = dateSelectionRequired;
        }
    }

    validateDates() {
        if (this.dateSelectionRequired && this.validate) {
            if (!this.dateFrom ||
                !this.dateTo) {
                this.dateRangeInvalid = true;
                this.dateValidationMessage = 'Date range selection is required';
                return false;
            }

            if (new Date(this.dateFrom) > new Date(this.dateTo)) {
                this.dateRangeInvalid = true;
                this.dateValidationMessage = 'To date should not be earlier than from date';
                return false;
            }
        }

        this.dateRangeInvalid = false;
        this.dateValidationMessage = '';

        return true;
    }

    getReport() {
        const self = this;
        this.validate = true;

        if (!this.validateDates()) {
            return;
        }

        this.validate = false;
        this.isDownloadingReport = true;
        this.noRecordsFound = false;

        const payload = {
            fromDate: this.dateFrom,
            toDate: this.dateTo,
            text: this.text
        };

        this.$http.post(`api/mireport/${this.reportName}`, payload)
           .then(result => {
               if (result && result.data) {
                   const downloadElement = document.getElementById('downloadReport');
                   downloadElement.setAttribute('href', result.data);
                   downloadElement.setAttribute('target', '_self');

                   downloadElement.click();
               } else {
                   self.noRecordsFound = true;
               }

               self.isDownloadingReport = false;
           })
           .catch(error => {
               self.noRecordsFound = false;
               self.isDownloadingReport = false;

               let errorText = error.data;
               if (!errorText) {
                   errorText = error.statusText;
               }

               if (errorText) {
                   this.toaster.error(errorText);
               }
           });
    }
}

export default function ($http, toaster) {
    return (reportName, dateSelectionRequired) => new MiReportService($http, toaster, reportName, dateSelectionRequired);
}



// WEBPACK FOOTER //
// ./Client/app/mireports/services/miReport/miReportServiceFactory.js